import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  getPhilipsPdcIconButtonClassName,
  getPhilipsPdcIconTitle,
  isPhilipsPdcDeviceReadyIndicatorVisible,
  isPhilipsPdcSidebarIconVisible,
} from "./philipsPdcUi";
import usePhilipsPdcPresence from "./usePhilipsPdcPresence";

/**
 * Sidebar SpeechMike icon: connection state, tooltip, and button styling.
 */
export default function usePhilipsPdcSidebarIcon() {
  const { t } = useTranslation();
  const philipsPdc = usePhilipsPdcPresence();

  const iconTitle = useMemo(
    () => getPhilipsPdcIconTitle(t, philipsPdc),
    [philipsPdc, t],
  );

  const iconButtonClassName = useMemo(
    () => getPhilipsPdcIconButtonClassName(philipsPdc.status),
    [philipsPdc.status],
  );

  return {
    philipsPdc,
    iconTitle,
    iconButtonClassName,
    showIcon: isPhilipsPdcSidebarIconVisible(philipsPdc.status),
    showDeviceReadyDot: isPhilipsPdcDeviceReadyIndicatorVisible(
      philipsPdc.status,
    ),
  };
}
